import { alpha, Box, Text, styled } from '@ltvco/refresh-lib/theme';
import { Link as RouterLink } from 'react-router-dom';

// ===================== HeroSection =====================

export const HeroTitleRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  marginBottom: theme.spacing(2),
}));

// ===================== ToolsSection =====================

export const PopularSearchesSectionRoot = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(5),
  [theme.breakpoints.up('md')]: {
    marginBottom: theme.spacing(6),
  },
}));

export const PopularSearchesTitle = styled(Text)(({ theme }) => ({
  fontWeight: 700,
  marginBottom: theme.spacing(2),
  color: theme.palette.text.primary,
})) as typeof Text;

export const PopularSearchesGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: theme.spacing(1.5),
  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(2),
  },
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
  },
}));

export const PopularSearchLinkLabel = styled(Text)(({ theme }) => ({
  fontWeight: 700,
  color: theme.palette.text.primary,
  lineHeight: 1.3,
})) as typeof Text;

export const PopularSearchToolLink = styled(RouterLink)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  gap: theme.spacing(1),
  minHeight: 88,
  textDecoration: 'none',
  color: 'inherit',
  backgroundColor: theme.palette.common.white,
  border: '1px solid',
  borderColor: theme.palette.grey[300],
  borderRadius: '12px',
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
  transition: theme.transitions.create(
    ['border-color', 'background-color', 'box-shadow'],
    { duration: theme.transitions.duration.shortest }
  ),
  '&:hover': {
    borderColor: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.04),
  },
  '&:focus-visible': {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: 2,
  },
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textAlign: 'left',
    gap: theme.spacing(1.5),
    minHeight: 52,
  },
}));

// ===================== ExploreByProductSection =====================

export const ExploreByProductSectionRoot = styled(Box)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
  paddingTop: theme.spacing(5),
  paddingBottom: theme.spacing(1),
  marginBottom: theme.spacing(3),
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(7.5),
    paddingBottom: 0,
    marginBottom: theme.spacing(5),
  },
}));

export const ExploreByProductHeading = styled(Text)(({ theme }) => ({
  fontWeight: 700,
  textAlign: 'center',
  marginBottom: theme.spacing(3),
  fontFamily: theme.typography.fontFamily,
  [theme.breakpoints.up('md')]: {
    marginBottom: theme.spacing(4.5),
  },
})) as typeof Text;
